module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGIAAAACCAYAAACjUQlUAAAA3UlEQVQ4T6WS3QrCMAxGT9ZuUxC88IV9YS8ELxR1ky9pmIgKYiFr2vy0/c5s3lOJ0fn3gLHDOGJsMU4YG6zFO84YVwpG5zZQgOr+hUr1mHoOTO4PHr8zuC+b6T0esZWvO0ZmRqD32dzUQ7375qtG56m+tjzdW2udVZg9HneKvcrU7hr7+Rb5ql3etvjak2mkH/os63c5LeX3yf4CIQgCcKPQU15ASIAQMEEoK4UP8SX6uuUI0AIiQSkvQQRACZyzeqfoAvYMQjn6Wb6BkGIJJKEkmBT6neCfYr8TaBUPoGMn72oF+F0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dzuo.png
// module id = OvBr
// module chunks = 18